import styled from '@emotion/styled'

interface Props {
  variant?: string
  resize?: boolean
}

const H3 = styled.h3<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    fontFamily: theme.fonts.families.headline,
    fontSize: '16px',
    fontWeight: 'bold',
    color: theme.colors.primary,
    lineHeight: '20px',
    letterSpacing: '0.8px',
    [theme.mediaQueries.maxDesktop]: {
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.6px,',
    },
  }),
  ({ variant, theme }) =>
    variant === 'labelMute' && {
      color: theme.colors.grays.gray,
      fontSize: theme.fonts.sizes.P.small,
      display: 'inline-flex',
      alignItems: 'center',
      textTransform: 'uppercase',
      marginTop: '0',
      marginBottom: '0',
      marginRight: '2em',
    },
  ({ resize }) => !!resize && { fontSize: '0.8vw', lineHeight: '1.0vw' }
)

export default H3
